import styled from 'styled-components';

export const Main = styled.main<{ $flexGrow?: boolean }>`
  ${(props) => props.$flexGrow && 'flex-grow: 1;'}
`;

export const Body = styled.div`
  margin-top: ${(props) => props.theme.headerSize.heightDesktop}px;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  @media (max-width: ${(props) => props.theme.breakpoints.lg}px) {
    margin-top: ${(props) => props.theme.headerSize.heightMobile}px;
  }
`;
